<script>
export default {
  name: 'ShowRequisition',
  data() {
    return {
      requisitionId: '',
      requisition: {
        createdAt: ''
      },
      requisitionDetail: [],
      requisitionRequests: [],
      departments: [],
      products: [],
      locations: [],
      usrs: [],
    };
  },
  methods: {
    printPage() {

      let printContents = document.getElementById('printMe').innerHTML;

      let printWindow = window.open('', '_blank');
      printWindow.document.write(`
<html>
    <style>
    .grid-container {
        display: grid;
        grid-template-columns: 1fr 1fr; /* this splits your container into two equal width columns */
        grid-gap: 1em; /* this is optional, it sets some space between your columns */
        width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .table-container {
        max-height: 500px;
        width: 808px;
        background: rgba(237, 237, 237, 0.68);
        border-color: #97989AFF;
        border-style: solid;
        border-width: 1px;
        border-radius: 8px;
        margin: 0 auto 20px auto;
    }

    .table-container table {
        width: 800px;
        border-collapse: collapse;
        margin-left: auto;
        margin-right: auto;
        font-family: 'SDE-Font-Regular', sans-serif;
    }

    .table-container table td {
        padding: 1px;
    }

    .table-container table thead th {
        background-color: #97989AFF;
        color: #f9f9f9;
        font-weight: bold;
        font-size: 15px;
        border: 1px solid #97989AFF;
        border-left: none;
    }

    .table-container table tbody td {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        text-align: left;
    }

    .table-container table tbody th {
        color: #97989AFF;
        border: 1px solid #97989AFF;
        font-size: 15px;
        border-left: none;
    }

    .table-container table tbody tr {
        background-color: #f9fafb;
    }

    .table-container table tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }

    .table-container table tbody tr:hover td {
        color: white;
    }

    .table-container table tbody tr:hover th {
        color: white;
    }

    .table-container thead tr th {
        position: sticky;
        top: -1px;
        box-shadow: 0px 2px 2px #f0f0f0; /* Adds a shadow */
        z-index: 1;
    }
    </style>
    <head>
        <title>Print</title>
    </head>
    <body>
        ${printContents}

<div style="align-content: center">
    <div style="height: 100px; width: 400px; border-bottom: solid black; border-bottom-width: 2px"></div>
    <label>Firma recibido</label>
  </div>

    </body>
</html>`
      );
      printWindow.document.close();
      printWindow.print();

    },
    async getRequisition(id) {
      try {
        let result = await this.$api.get(`/auth/requisitions/${id}`, {})
        if (result.status.toString() === "200") {
          this.requisition = result.data
          if (this.requisition === null) {
            this.requisition = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getRequisitionDetails(id) {
      try {
        let result = await this.$api.get(`/auth/requisitions/${id}/details`, {
        })
        if (result.status.toString() === "200") {
          this.requisitionDetail = result.data
          if (this.requisitionDetail === null) {
            this.requisitionDetail = []
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
      try {
        let result = await this.$api.get(`/auth/requisitions/${id}/requests`, {})
        if (result.status.toString() === "200") {
          this.requisitionRequests = result.data
          if (this.requisitionDetail === null) {
            this.requisitionRequests = []
          }
        }

      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    async getUsrs() {
      try {
        let result = await this.$api.get("/auth/users")
        if (result.status.toString() === "200") {
          this.usrs = result.data
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la informacion',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getDepartments() {
      try {
        let res = await this.$api.get("/auth/departments");
        if (res.status.toString() === "200") {
          this.departments = res.data
        }
      } catch (error) {
        console.log("can't get departments data")
      }
    },
    getProductById(id) {
      return this.products.find(product => product.id === id) || {}
    },
    getDepartmentById(id) {
      return this.departments.find(department => department.id === id) || {}
    },
    getUserById(id) {
      return this.usrs.find(usr => usr.id === id) || {}
    },
    countProductDispatched(id){
      let count = 0
      for (const detail of this.requisitionDetail) {
        if (detail.product === id) {
          count = detail.quantity + count
        }
      }
      return count
    }
  },
  created() {
    this.requisitionId = this.$route.params.id;
    this.getRequisition(this.requisitionId)
    this.getRequisitionDetails(this.requisitionId)
    this.getProd()
    this.getLocation()
    this.getUsrs()
    this.getDepartments()
  }
}

</script>

<template>
  <div id="printMe">
    <h1>Requisición</h1>
    <div class="grid-container"
         style="padding-top: 40px; padding-left: 40px; padding-bottom: 40px; background-color: rgba(39, 51, 116, 0.1); border-radius: 30px;">
      <!-- Column 1 -->
      <div style="text-align: left;">
        <label>Código:</label>
        <p>{{ requisition.code }}</p>

        <label>Registrado por:</label>
        <p>{{ getUserById(requisition.requestedBy).firstname }} {{ getUserById(requisition.requestedBy).lastname }}</p>

      </div>

      <div style="text-align: left">
        <label>Departamento:</label>
        <p>{{ getDepartmentById(requisition.department).title }}</p>

        <label>Fecha:</label>
        <p>{{ requisition.createdAt.substring(0, 10) +" "+ requisition.createdAt.substring(11, 19) }}</p>


      </div>
    </div>

    <div style="height: 20px;"></div>

    <label style="font-weight: bold;">Resumen</label>

    <div class="container mt-4 table-container" style="margin-top: 40px">
      <table id="myTable">
        <thead>
        <tr>
          <th>#</th>
          <th>Producto</th>
          <th>Solicitado</th>
          <th>Despachado</th>
        </tr>

        </thead>
        <tbody>
        <tr v-for="(product, index) in requisitionRequests" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ getProductById(product.product).title }}</td>
          <td>{{ product.quantity }}</td>
          <td>{{ countProductDispatched(product.product) }}</td>
        </tr>
        </tbody>
      </table>

    </div>

    <label style="font-weight: bold;">Detalle producto despachado</label>

    <div class="container mt-4 table-container" style="margin-top: 40px">
      <table id="myTable">
        <thead>
        <tr>
          <th>#</th>
          <th>Producto</th>
          <th>Cantidad</th>
          <th>Código de barras</th>
          <th>Lote</th>
          <th>Expira</th>
        </tr>

        </thead>
        <tbody>
        <tr v-for="(product, index) in requisitionDetail" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ getProductById(product.product).title }}</td>
          <td>{{ product.quantity }}</td>
          <td>{{ product.barcode }}</td>
          <td>{{ product.itemBatch }}</td>
          <td>{{ product.expires.substring(0, 4) === "0000" ? '' : product.expires.substring(0, 10) }}</td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>

  <button @click="printPage">Imprimir</button>


</template>

<style>


</style>